'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMixin = require('react-mixin');

var _reactMixin2 = _interopRequireDefault(_reactMixin);

var Mixin = require('../mixin');
var Glyph = require('./Glyph');

var Select = (function (_React$Component) {
    _inherits(Select, _React$Component);

    function Select(props) {
        _classCallCheck(this, Select);

        _get(Object.getPrototypeOf(Select.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Select';
        var state = this.getSelectedOption(this.props) || {};
        state.isOpen = false;

        this.state = state;
    }

    _createClass(Select, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState(this.getSelectedOption(nextProps));
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            // Scroll menu while navigating through options in case of accessibility (using keyboard).
            if (this.state.isOpen && this.refs.focused) {
                var focusedRect = this.refs.focused.getBoundingClientRect(),
                    menuRect = this.refs.menu.getBoundingClientRect(),
                    focusedDOM = _reactDom2['default'].findDOMNode(this.refs.focused),
                    menuDOM = _reactDom2['default'].findDOMNode(this.refs.menu);

                if (focusedRect.bottom > menuRect.bottom) {
                    menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.clientHeight;
                } else if (focusedRect.top < menuRect.top) {
                    menuDOM.scrollTop = focusedDOM.offsetTop;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var lis = [],
                options = [{
                label: this.props.placeholder,
                value: ''
            }].concat(this.props.options);

            var selectDropdownStyles = {},
                hasError = this.props.errors.length,
                isBlur = !this.state.selectedOption.value;

            if (!this.state.selectedOption.value && !this.props.readOnly && this.context.type !== 'basic' && this.context.type !== 'horizontal') {
                selectDropdownStyles = {
                    visibility: 'hidden'
                };
            }
            var focused = false;
            options.forEach((function (option, i) {
                focused = this.findInObject(options[this.state.focusedOptionIndex], 'value') === option.value;
                lis.push(_react2['default'].createElement(
                    'li',
                    {
                        key: option.value + '-' + i,
                        id: option.value + '-' + i,
                        className: (0, _classnames2['default'])('Select-menu-options', {
                            'Select-menu-options-focused': focused
                        }),
                        ref: focused ? 'focused' : '',
                        onClick: this.onChange.bind(this, option)
                    },
                    option.label
                ));
            }).bind(this));

            var _props = this.props;
            var leftPadding = _props.leftPadding;
            var rightPadding = _props.rightPadding;

            var errorIcon = hasError ? _react2['default'].createElement(Glyph, {
                size: 'small',
                type: 'error',
                icon: 'icon-critical-small',
                className: (0, _classnames2['default'])('Select-error-icon'),
                style: {
                    paddingLeft: leftPadding ? leftPadding : null,
                    paddingRight: rightPadding ? rightPadding : null
                }
            }) : null;

            var arrowIcon = !hasError && !this.props.readOnly ? _react2['default'].createElement(Glyph, {
                size: 'small',
                icon: this.state.isOpen ? 'icon-arrow-up-small' : 'icon-arrow-down-small',
                className: (0, _classnames2['default'])('Select-arrow-icon'),
                style: {
                    paddingLeft: leftPadding ? leftPadding : null,
                    paddingRight: rightPadding ? rightPadding : null
                }
            }) : null;

            var componentLabel = this.props.label ? _react2['default'].createElement(
                'label',
                {
                    className: (0, _classnames2['default'])('ComponentLabel', {
                        'ComponentLabel-blur': isBlur,
                        'ComponentLabel-error': hasError,
                        'ComponentLabel-readOnly': this.props.readOnly
                    }),
                    style: {
                        paddingLeft: leftPadding ? isBlur ? leftPadding : 'calc(' + leftPadding + ' * 1.45)' : null
                    },
                    htmlFor: this.props.id || this.props.htmlFor
                },
                this.props.label
            ) : null;

            var selectProps = {
                id: this.props.id,
                className: (0, _classnames2['default'])('Select', {
                    error: hasError
                }, this.props.className),
                onBlur: this.onBlur.bind(this),
                onKeyDown: this.onKeyDown.bind(this),
                onKeyPress: this.onKeyPress.bind(this)
            };

            // Set tabIndex only for active select dropdown.
            if (!(this.props.readOnly || this.props.disabled)) {
                selectProps['tabIndex'] = '0'; // Set tabIndex to make onBlur work.
            }

            return _react2['default'].createElement(
                'div',
                selectProps,
                componentLabel,
                _react2['default'].createElement(
                    'div',
                    {
                        className: (0, _classnames2['default'])('Select-label', {
                            'Select-label-focused': this.state.isOpen,
                            'Select-label-disabled': this.props.disabled,
                            'Select-label-readOnly': this.props.readOnly
                        }),
                        onClick: this.onClick.bind(this),
                        style: {
                            paddingLeft: leftPadding ? leftPadding : null,
                            paddingRight: rightPadding ? hasError ? 'calc(' + rightPadding + ' + 3em)' : rightPadding : null
                        }
                    },
                    _react2['default'].createElement(
                        'span',
                        { className: 'Select-label-text', style: selectDropdownStyles },
                        this.state.selectedOption.label
                    ),
                    arrowIcon,
                    errorIcon
                ),
                _react2['default'].createElement(
                    'ul',
                    {
                        className: (0, _classnames2['default'])('Select-menu', {
                            'Select-menu-show': this.state.isOpen,
                            'Select-menu-hide': !this.state.isOpen
                        }),
                        ref: 'menu'
                    },
                    lis
                )
            );
        }
    }, {
        key: 'getSelectedOption',
        value: function getSelectedOption(props) {
            // Set default 'selected' option as selected option.
            var options = props.options || [],
                selectedOption = {
                label: props.placeholder,
                value: ''
            };

            var selectectedIndex = 0;

            for (var i = 0; i < options.length; i++) {
                if (options[i].value === props.value) {
                    selectedOption = {
                        label: options[i].label,
                        value: options[i].value
                    };
                    selectectedIndex = i + 1; //Considering placeholder as zeroth index.
                    break;
                }
            }
            return {
                selectedOption: selectedOption,
                focusedOptionIndex: selectectedIndex
            };
        }
    }, {
        key: 'onKeyPress',
        value: function onKeyPress(event) {
            if (this.props.disabled || this.props.readOnly) {
                return false;
            }

            var key = event.key,
                options = this.props.options,
                option = '',
                state = {};

            switch (key) {
                case 'Enter':
                    {
                        // Do nothing. 'Enter' handled in onKeyDown
                        break;
                    }
                default:
                    {
                        this.key = this.key || '';
                        this.key += key;
                        if (options) {
                            for (var i = 0; i < options.length; i++) {
                                option = options[i];
                                if (option.label.toUpperCase().indexOf(this.key.toUpperCase()) === 0) {
                                    state.focusedOptionIndex = i + 1;
                                    if (!this.state.isOpen) {
                                        state.isOpen = true;
                                    }
                                    this.setState(state);
                                    return;
                                }
                            }

                            //Reset key when no match found
                            this.key = '';
                        }
                    }
            }
        }
    }, {
        key: 'onKeyDown',
        value: function onKeyDown(event) {
            if (this.props.disabled || this.props.readOnly) {
                return false;
            }
            var keyCode = event.keyCode;

            switch (keyCode) {
                case 40:
                    {
                        //Down arrow

                        //Navigate down through the options.
                        this.optionsNavigateDown();
                        break;
                    }
                case 38:
                    {
                        //Up arrow

                        //Navigate up through the options.
                        this.optionsNavigateUp();
                        break;
                    }
                case 27:
                    {
                        // ESC

                        // Close Menu options.
                        if (this.state.isOpen) {
                            this.hideOptions();
                        }
                        break;
                    }
                case 13:
                    {
                        //Enter

                        //Choose selected option and trigger onChange function.
                        var selectedOption = this.state.focusedOptionIndex > 0 ? this.props.options[this.state.focusedOptionIndex - 1] : { label: this.props.placeholder, value: '' };
                        this.onChange.bind(this)(selectedOption);
                        break;
                    }

                default:
            }
        }
    }, {
        key: 'optionsNavigateDown',
        value: function optionsNavigateDown() {
            if (!this.state.isOpen) {
                this.setState({
                    isOpen: true
                });
            } else {
                if (this.state.focusedOptionIndex < this.props.options.length) {
                    this.setState({
                        focusedOptionIndex: this.state.focusedOptionIndex + 1
                    });
                }
            }
        }
    }, {
        key: 'optionsNavigateUp',
        value: function optionsNavigateUp() {
            if (this.state.isOpen && this.state.focusedOptionIndex > 0) {
                this.setState({
                    focusedOptionIndex: this.state.focusedOptionIndex - 1
                });
            }
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            this.setState({
                isOpen: !this.state.isOpen
            });
        }
    }, {
        key: 'onBlur',
        value: function onBlur(event) {
            var relatedTarget = event.relatedTarget || document.activeElement; // IE11

            if (!relatedTarget || !event.currentTarget.contains(relatedTarget)) {
                this.hideOptions();
            }

            return true;
        }
    }, {
        key: 'hideOptions',
        value: function hideOptions() {
            //Reset Key
            this.key = '';

            var state = this.getSelectedOption(this.props) || {};
            state.isOpen = false;

            this.setState(state);
        }
    }, {
        key: 'onChange',
        value: function onChange(selectedOption, event) {
            //Check if the option has changed.
            var isChanged = this.state.selectedOption.label !== selectedOption.label;
            this.setState({
                isOpen: false,
                selectedOption: selectedOption
            });

            //Reset Key
            this.key = '';

            //Call User defined onChange method.
            if (this.props.onChange && isChanged) this.props.onChange(selectedOption.value, event);
        }
    }]);

    return Select;
})(_react2['default'].Component);

Select.propTypes = {
    options: _propTypes2['default'].arrayOf(_propTypes2['default'].object).isRequired,
    onChange: _propTypes2['default'].func.isRequired,
    placeholder: _propTypes2['default'].string.isRequired,
    id: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    readOnly: _propTypes2['default'].bool,
    value: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
    errors: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
    leftPadding: _propTypes2['default'].string,
    rightPadding: _propTypes2['default'].string
};

Select.defaultProps = {
    errors: []
};

Select.contextTypes = {
    type: _propTypes2['default'].string
};

(0, _reactMixin2['default'])(Select.prototype, Mixin);

module.exports = Select;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Select.js
// module id = 173
// module chunks = 0 1